if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function () {


    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */
    const accTitle = document.querySelectorAll('.accordionItemHeading');
    const accParent = document.querySelectorAll('.js-accordion')
    if (accTitle) {
        accTitle.forEach(function (acc) {
            acc.addEventListener('click', function (e) {
                e.preventDefault()
                if (this.parentElement.classList.contains('active')) {
                    this.parentElement.classList.remove('active')
                } else {
                    accParent.forEach(function (item) {
                        item.classList.remove('active')
                    })
                    this.parentElement.classList.add('active')
                }
            })
        })
    }


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true,
        autoplay: true,
        arrows: false,
        dots: false

    });

    // mobile slider
    $('.video-columns__slider').not('.slick-initialized').slick({
        accessibility: true,
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: false,
        slidesToShow: 1,
    });

    $('.how-it-works__slider').not('.slick-initialized').slick({
        accessibility: true,
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: false,
        slidesToShow: 1,
    });


    //slider with nav timer used on slider shortcode
    $('.slider-block__nav').each(function () {
        $(this).slick({
            accessibility: true,
            pauseOnHover: false,
            autoplay: true,
            autoplaySpeed: 15000,
            focusOnSelect: true,
            dots: true,
            arrows: false,
            fade: true,
            adaptiveHeight: true,
            appendDots: $(this).siblings('.slider-dots__box'),
            dotsClass: 'slider-dots',
        });
        // On before slide change
        $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slider-dots__box button').html('');
        }).trigger('beforeChange');
        // On before slide change
        $(this).on('afterChange', function (event, slick, currentSlide) {
            if (typeof currentSlide === 'undefined') {
                currentSlide = 0;
            }
            $('.slider-dots__box .slick-active button')
                .append(`<span>` + (currentSlide + 1) + `</span><svg class="progress-svg" width="30" height="30">
        <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="50%" y2="100%">
            <stop offset="0%" stop-color="#C7EFF5" />
            <stop offset="100%" stop-color="#38939b" />
            </linearGradient>
        </defs>
    <g transform="translate(15,15)">
        <circle cx="0" cy="0" r="14" fill="transparent" stroke="rgb(202,202,204)" stroke-width="1" />
        <circle class="circle-go" r="14" cx="0" cy="0" stroke="url(#gradient)" stroke-width="1" fill="none" ></circle>
    </g>
    </svg>
        `
                );
        }).trigger('afterChange');
    });


    //slider with nav timer used on slider shortcode
    $('.dayslider-block__nav').each(function () {
        $(this).slick({
            accessibility: true,
            pauseOnHover: false,
            autoplay: true,
            autoplaySpeed: 15000,
            focusOnSelect: true,
            dots: true,
            arrows: true,
            // fade: true,
            adaptiveHeight: true,
            appendDots: $(this).siblings('.slider-dots__box'),
            dotsClass: 'slider-dots',
            slidesToShow: 3,
            centerMode: true,
            centerPadding: '130px',
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        centerPadding: '30px',
                        arrows: false
                    },
                    breakpoint: 640,
                    settings: {
                        centerPadding: '0px',
                        slidesToShow: 1,
                        arrows: false,
                        centerMode: false
                    }
                }
            ]
        });
        // On before slide change
        $(this).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.slider-dots__box button').html('');
        }).trigger('beforeChange');
        // On before slide change
        $(this).on('afterChange', function (event, slick, currentSlide) {
            if (typeof currentSlide === 'undefined') {
                currentSlide = 0;
            }
            $('.slider-dots__box .slick-active button')
                .append(`<span>` + (currentSlide + 1) + `</span><svg class="progress-svg" width="30" height="30">
        <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="50%" y2="100%">
            <stop offset="0%" stop-color="#C7EFF5" />
            <stop offset="100%" stop-color="#38939b" />
            </linearGradient>
        </defs>
    <g transform="translate(15,15)">
        <circle cx="0" cy="0" r="14" fill="transparent" stroke="rgb(202,202,204)" stroke-width="1" />
        <circle class="circle-go" r="14" cx="0" cy="0" stroke="url(#gradient)" stroke-width="1" fill="none" ></circle>
    </g>
    </svg>
        `
                );
        }).trigger('afterChange');

    });






    /*** end slick ***/

    //gallery with nav timer used on slider shortcode
    $('.gallery-block__nav').not('.slick-initialized').slick({
        accessibility: true,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 5000,
        focusOnSelect: false,
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        //appendDots: $('.gallery-dots__box1'),
        //dotsClass: 'slider-dots-gallery',
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    autoplay: false
                }
            },
        ]
    });
    // On before slide change
    $('.gallery-block__nav').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.gallery-dots__box button').html('');
    }).trigger('beforeChange');
    // On before slide change
    $('.gallery-block__nav').on('afterChange', function (event, slick, currentSlide) {
        if (typeof currentSlide === 'undefined') {
            currentSlide = 0;
        }
        $('.gallery-dots__box .slick-active button')
            .append(`<span>` + (currentSlide + 1) + `</span><svg class="progress-svg" width="30" height="30">
        <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="50%" y2="100%">
            <stop offset="0%" stop-color="#C7EFF5" />
            <stop offset="100%" stop-color="#38939b" />
            </linearGradient>
        </defs>
    <g transform="translate(15,15)">
        <circle cx="0" cy="0" r="14" fill="transparent" stroke="rgb(202,202,204)" stroke-width="1" />
        <circle class="circle-go" r="14" cx="0" cy="0" stroke="url(#gradient)" stroke-width="1" fill="none" ></circle>
    </g>
    </svg>
        `
            );
    }).trigger('afterChange');
    /*** end slick ***/

})();